import {
  Component,
  QueryList,
  ViewChildren,
} from "@angular/core";
import {
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { AsyncPipe, NgFor, NgIf } from "@angular/common";
import { MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from "@angular/material/datepicker";
import { MatFormField, MatInput, MatLabel, MatSuffix } from "@angular/material/input";
import { MatIcon } from "@angular/material/icon";
import { MatOption } from "@angular/material/autocomplete";
import { MatSelect } from "@angular/material/select";
import { MatTooltip } from "@angular/material/tooltip";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { Area } from "src/app/shared/model/tickets/area.model";
import { Tickets } from "src/app/shared/model/tickets/tickets.model";
import { Constantes } from "src/app/utilerias/constantes/constantes";
import { ReportesTicketsComponent } from "../../general/reportes-tickets/reportes-tickets.component";
import { NotificacionCteTicketComponent } from "../../solicitud/notificacion-cte-ticket/notificacion-cte-ticket.component";
import {
  TableroTicketsBaseComponent,
  VistaTableroTickets,
} from "../../tickets-comun/tablero-tickets-base.component";
import { NotificacionTicketComponent } from "../notificacion-ticket/notificacion-ticket.component";

/** Tablero de atención; pinta la plantilla del tablero del cliente con sus propios textos, clases y columnas. */
@Component({
  selector: "app-gestion-tickets",
  standalone: true,
  templateUrl: "../../solicitud/gestion-cte-tickets/gestion-cte-tickets.component.html",
  styleUrls: ["./gestion-tickets.component.css"],
  imports: [
    AsyncPipe,
    FormsModule,
    MatButtonModule,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
    MatSuffix,
    MatTooltip,
    NgFor,
    NgIf,
    NgxMatSelectSearchModule,
    NotificacionCteTicketComponent,
    NotificacionTicketComponent,
    ReactiveFormsModule,
  ],
})
export class GestionTicketsComponent extends TableroTicketsBaseComponent {
  readonly vista: VistaTableroTickets = {
    clasePagina: "tickets-admin-page",
    iconoAccion: "summarize",
    textoAccion: "Reporte",
    accionSecundaria: true,
    columnasCliente: false,
    textoSinAreas: "No fue posible cargar las áreas resolutoras para el tablero de tickets.",
  };

  dialogRef: MatDialogRef<any> | null = null;
  ticket = new Tickets();

  @ViewChildren(NotificacionTicketComponent)
  ticketBoards!: QueryList<NotificacionTicketComponent>;

  protected get prefijoPaginacion(): string {
    return "ticket-board";
  }

  accionPrincipal(): void {
    this.abrirReportes();
  }

  abrirReportes(): void {
    if (this.dialog.openDialogs.length > 0) {
      return;
    }

    // El reporte abre con el área que el tablero tiene seleccionada (0 = todas).
    // Se ancla debajo del topbar: es fixed con z-index 12000 y, centrado,
    // un diálogo alto (en teléfono siempre) le quedaba con la cabecera y el
    // botón de cerrar debajo.
    this.dialogRef = this.dialog.open(ReportesTicketsComponent, {
      panelClass: "app-standard-dialog",
      backdropClass: "app-standard-dialog-backdrop",
      width: "640px",
      maxWidth: "calc(100vw - 32px)",
      maxHeight: "calc(100vh - var(--solser-topbar-height, 68px) - 32px)",
      position: { top: "calc(var(--solser-topbar-height, 68px) + 16px)" },
      autoFocus: "first-tabbable",
      restoreFocus: true,
      ariaLabelledBy: "tickets-reporte-titulo",
      ariaDescribedBy: "tickets-reporte-ayuda",
      data: { idArea: this.areaSeleccionada?.id ?? 0 },
    });
  }

  protected asignarAreas(areasCatalogo: Area[], areasUsuario: Area[]): void {
    if (!areasUsuario.length) {
      this.areas = [];
      this.filterArea.next([]);
      return;
    }

    const todas = this.buildTodasArea(areasCatalogo[Constantes.CERO]);
    this.areas = [...areasCatalogo, todas];
    this.areaSeleccionada = { ...todas };
    this.filterArea.next(this.areas.slice());
    this.options.patchValue({ areaCtrl: this.areaSeleccionada }, { emitEvent: false });
    this.deferRefreshAll();
  }

  private buildTodasArea(areaBase: Area): Area {
    const todas = new Area();
    todas.id = 0;
    todas.area = "Todas";
    todas.estatus = areaBase?.estatus;
    todas.defaultService = areaBase?.defaultService;
    todas.listPuesto = areaBase?.listPuesto;
    todas.tipo = areaBase?.tipo;

    return todas;
  }
}
